import { CreateWorkFlowComponent } from './../create/create.component';
import { ServicesService } from './../../../../../administaration/services/services/servicesService';
import { WorkFlowVm } from './../../models/workFlowVm';
import { WorkflowDetailsComponent } from './../workflow-details/workflow-details.component';
import { Router } from '@angular/router';
import { WorkFlowService } from './../../services/work-flow.service';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { QueryModel } from '../../../../../shared/Models/queryModel';
import { NbComponentStatus, NbDialogService, NbToastrService, NbWindowService } from '@nebular/theme';
import { Form, FormBuilder, FormGroup } from '@angular/forms';
import { BaseComponent } from '../../../../../shared/Components/base/base.component';
import { PagingService } from '../../../../../shared/Services/PagingService';
import { ConfirmationDialogComponent } from '../../../../../shared/Components/confirmation-dialog.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ngx-workflow-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetComponent extends BaseComponent implements OnInit {
  workflows: WorkFlowVm[];
  comName;
  @Input() objectName;
  @Input() objectRefId;
  @Input() workFlow;
  @Input() allowWorkflow = false;
  @Input() serviceName;
  form: FormGroup;

  @ViewChild('contentTemplate', { static: false }) contentTemplate: TemplateRef<any>;
  selectedId: number;
  windowref: any;
  constructor(
    service: WorkFlowService,
    public route: Router,
    private toast: NbToastrService,
    private dialogService: NbDialogService,
    private windowService: NbWindowService,
    private fb: FormBuilder,
    private ser: ServicesService,
    private paging: PagingService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }

  initForm() {
    this.form = this.fb.group({
      name: [''],
    });
  }

  handleSearch() {
    if (this.form.value.name == '') {
      this.toast.danger('برجاءاختيار الاسم لاتمام عملية البحث', 'رساله تحذيرية');
    } else {
      this.pagingModel.query.searchTerm = `name:${this.form.value.name.trim()}`;
      this.loadEntities();
    }
  }

  clearFilter() {
    this.form.controls['name'].setValue('');
    this.pagingModel.query.searchTerm = '';
    this.loadEntities();
  }

  loadWorkFlows() {
    this.loadEntities();
  }

  addNew() {
    // const route = ['admin/workflow/new'];
    // this.route.navigate(route);

    this.dialogService.open(CreateWorkFlowComponent).onClose.subscribe((res) => {
      if (res === 'true') this.loadWorkFlows();
    });
  }

  phases(id) {
    const route = ['admin/workflow/new/' + this.objectRefId + '/' + this.objectName];
    this.route.navigate(route);
  }
  Details(item: any) {
    const route = ['admin/workflow/detail/' + item.id];
    this.route.navigate(route);
    // this.dialogService.open(WorkflowDetailsComponent, { context: { model: item } });
  }
  delete(id: number) {
    this.dialogService
      .open(ConfirmationDialogComponent, {
        context: { message: 'Are you sure you want to delete this item?' } as Partial<ConfirmationDialogComponent>,
      })
      .onClose.subscribe((result) => {
        if (result) {
          this.service.delete(id).subscribe(() => {
            this.toast.show('تم حذف سير العمل بنجاح', '', { status: 'success', duration: 3000 });
            this.loadWorkFlows();
          });
        }
      });
  }

  deleteItem() {
    const position = 'bottom-right';
    this.service.delete(this.selectedId).subscribe((res) => {
      this.windowref.close();
      this.showToast(position, 'تم حذف سير العمل بنجاح', 'success');
      this.loadWorkFlows();
    });
  }

  showToast(position, message, status: NbComponentStatus) {
    this.toast.show(message, '', { position, status });
  }

  editWorkflow(workflow) {
    console.log({ workflow });
    const copymodel = {...workflow}
    this.dialogService
      .open(CreateWorkFlowComponent, { context: { workflowVm: copymodel, isEdit: true } })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadWorkFlows();
      });
  }

  // setPage(page: number) {
  //   this.finishLoading = false;
  //   this.paging.setPage(page, this.pagingModel, this.service);
  //   this.finishLoading = true;
  // }
}
